import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import configureStore from "./redux/store";
import httpClient from "./httpClient";
import applyDefaultInterceptors from "./httpClient/applyDefaultInterceptors";
import { StyledEngineProvider } from "@mui/material";
import { isAppEnvironmentProd } from "./utils/environment";

const { persistor, store } = configureStore();

applyDefaultInterceptors(store, httpClient);

if (isAppEnvironmentProd) {
  const segment = document.createElement("script");
  segment.innerHTML = `!(function () {
    var analytics = (window.analytics = window.analytics || []);
    if (!analytics.initialize)
      if (analytics.invoked)
        window.console &&
          console.error &&
          console.error("Segment snippet included twice.");
      else {
        analytics.invoked = !0;
        analytics.methods = [
          "trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group",
          "track","ready","alias","debug","page","once","off","on","addSourceMiddleware",
          "addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"
        ];
        analytics.factory = function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments);
            t.unshift(e);
            analytics.push(t);
            return analytics;
          };
        };
        for (var e = 0; e < analytics.methods.length; e++) {
          var key = analytics.methods[e];
          analytics[key] = analytics.factory(key);
        }
        analytics.load = function (key, e) {
          var t = document.createElement("script");
          t.type = "text/javascript";
          t.async = !0;
          t.src = "https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";
          var n = document.getElementsByTagName("script")[0];
          n.parentNode.insertBefore(t, n);
          analytics._loadOptions = e;
        };
        analytics._writeKey = "aSg2Ndw7QpirCAnVJULm8ESSTtrPETtp";
        analytics.SNIPPET_VERSION = "4.15.3";
        analytics.load("aSg2Ndw7QpirCAnVJULm8ESSTtrPETtp");
        analytics.page();
      }
  })();`;
  document.head.appendChild(segment);

  const adroll = document.createElement("script");
  adroll.innerHTML = `
    adroll_adv_id = "3ORIW6JNN5GSPFI2QH2U4Y";
    adroll_pix_id = "GCMNIOSVHRC7BO6VQGIHEK";
    adroll_version = "2.0";
    (function (w, d, e, o, a) {
      w.__adroll_loaded = true;
      w.adroll = w.adroll || [];
      w.adroll.f = ["setProperties", "identify", "track"];
      var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js";
      for (a = 0; a < w.adroll.f.length; a++) {
        w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || function(n) {
          return function() {
            w.adroll.push([n, arguments]);
          };
        }(w.adroll.f[a]);
      }
      e = d.createElement("script");
      o = d.getElementsByTagName("script")[0];
      e.async = 1;
      e.src = roundtripUrl;
      o.parentNode.insertBefore(e, o);
    })(window, document);
    adroll.track("pageView");
  `;
  document.head.appendChild(adroll);

  const hotjar = document.createElement("script");
  hotjar.innerHTML = `
    (function(h,o,t,j,a,r){
    h.hj=h.hj||function() {(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:6434707,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
  document.head.appendChild(hotjar);
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
